<!-- <pre> {{ sections_status | json }}</pre> -->




<div class="row mb-5">
    <div class="col-12 ">

        <div class="card">
            <!-- <img src="..." class="card-img-top" alt="..."> -->
            <div class="card-body">
                <h5 class="card-title">Datos basicos
                    <span  class="float-end fas fa-check text-success ps-1 small"></span>

                </h5>

                <p class="card-text"> <span class="text-capitalize fw-bold">{{person?.person?.name}} {{person?.person?.lastName}}</span> <br> {{person?.person?.gender == 'M'?'Masculino':'Femenino'}} , {{getIdentity(person)}} <br> Fecha de nacimiento {{person?.person?.birth_date | date: 'dd/MM/yyyy'}}, <br>
                    {{ person.person.marital_status.name }}
                </p>
                <!-- <div class="w-100 text-end mt-4">
                    <a href="#" class="btn btn-primary ">Editar</a>
                </div> -->

                <div class="w-100 text-end mt-4">
                    <a class="btn btn-primary" (click)="setChange(7)" *ngIf="_auth.hasPermission('contactos.onboarding.editar_datos')">Editar</a>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12  mt-4">

        <div class="card">
            <!-- <img src="..." class="card-img-top" alt="..."> -->
            <div class="card-body">

                <h5 class="card-title">Contactos
                    <span *ngIf="sections_status['CONTACT_ONB_APK'] ==  'COMPLETE'" class="float-end fas fa-check text-success ps-1 small"></span>

                </h5>
                <p class="card-text">


                    Teléfono Principal   <span class="fw-bold" >  {{getContact(person)}}   </span>

                    <span class="fw-bold" *ngIf="getPhoneCellHasWhatsapp(person)"> <i class="text-success fab fa-whatsapp"></i> </span><br>
                   <ng-container *ngIf="getContact2(person)">Teléfono adicional   <span class="fw-bold"  >  {{getContact2(person)}}   </span> <br>  </ng-container>  <br>

                   Email <span class="fw-bold" > {{getEmailContact(person)}} </span>
                </p>
                <!-- <div class="w-100 text-end mt-4">
                    <a href="#" class="btn btn-primary ">Editar</a>
                </div> -->
            </div>
        </div>
    </div>

    <div class="col-12 mt-4">
      <div class="card">
          <div class="card-body">
              <h5 class="card-title">Direcciones
                  <span *ngIf="sections_status['HOME_ADDRESS_ONB_APK'] ==  'COMPLETE'" class="float-end  fas fa-check text-success ps-1 small"></span>

              </h5>
              <div class="card-text small">

                  <div *ngIf="!loadPerson_Address">
                      <span *ngIf="sections_status['HOME_ADDRESS_ONB_APK'] ==  'COMPLETE' && personAddress?.length < 1" class="float-end  fas fa-check text-success ps-1 small"></span>

                      <div class="mt-2" *ngFor="let item of personAddress; let i=index">
                          <div *ngIf="i > 1">
                              <hr>
                          </div>
                          <b>{{item?.address_type?.name}}</b>,{{item?.address?.country?.description}}, {{item?.address?.state?.name}}, {{item?.address?.city?.name}}, {{item?.address?.description}}
                          <span  class="fw-bold" *ngIf="item?.housing_condition">                            ({{item?.housing_condition}})
                          </span>
                      </div>


                  </div>


                  <ng-container *ngIf="loadPerson_Address">
                      <div class="w-100 text-center mt-2">
                          <img src="./assets/public/images/loading.gif  " alt=" ">
                      </div>
                  </ng-container>

              </div>
              <!-- <div class="w-100 text-end mt-4">
                  <a class="btn btn-primary " (click)="setChange(2)">Editar</a>
              </div> -->
          </div>
      </div>
  </div>

  <div class="col-12 mt-4">
    <div class="card">
        <div class="card-body">
            <h5 class="card-title">Condición Laboral
                <span *ngIf="sections_status['WORKING_INF_ONB_APK'] ==  'COMPLETE'" class=" float-end  fas fa-check text-success ps-1 small"></span>

            </h5>
            <p *ngIf="sections_status['WORKING_INF_ONB_APK'] !=  'COMPLETE'" class="text-secondary small"> Pendiente</p>



            <p class="card-text">Condición Laboral <span *ngIf="customer?.working_condition != 'Otro'" class="fw-bold">{{customer?.working_condition}}</span></p>
            <p class="card-text">Descripción <span class="fw-bold">{{customer?.working_condition_descripion}}</span> </p>

            <p class="card-text" *ngIf="customer?.job_type" >Tipo de empleo <span class="fw-bold"  > {{customer?.job_type}} </span> </p>
            <p class="card-text" *ngIf="customer?.company_name" >Nombre de la empresa donde labora <span class="fw-bold" > {{customer?.company_name}} </span> </p>
            <p class="card-text" *ngIf="customer?.position">Cargo en la empresa donde labora <span class="fw-bold" > {{customer?.position}} </span> </p>
            <p class="card-text" *ngIf="customer?.admission_date">Fecha de ingreso a la empresa <span class="fw-bold" > {{customer?.admission_date | date: 'dd/MM/yyyy' }} </span> </p>
            <p class="card-text"  *ngIf="customer?.egress_date">Fecha de egreso de la empresa para la condición laboral Jubiliado y pensionado<span class="fw-bold"> {{customer?.egress_date | date: 'dd/MM/yyyy'}} </span> </p>

           <!--   <div *ngIf="!estatus_approve"  class="w-100 text-end mt-4">
                <a class="btn btn-primary " (click)="setChange(3)">Editar</a>
            </div>-->
        </div>
    </div>
</div>

<div class="col-12 mt-4">
  <div class="card">
      <div class="card-body">
          <h5 class="card-title">Finanzas
              <span *ngIf="sections_status['FINANCE_ONB_APK'] ==  'COMPLETE'" class="float-end  fas fa-check text-success ps-1 small"></span>
          </h5>

          <p class="card-text">Ingresos Mensuales <span class="fw-bold" >{{customer?.amount}} USD</span> </p>

          <p class="card-text" *ngIf="customer?.other_income" >Otros ingresos<span class="fw-bold"  > {{customer?.other_income}} USD</span> </p>
          <p class="card-text" *ngIf="customer?.monthly_expenses" >Gastos mensuales<span class="fw-bold"  > {{customer?.monthly_expenses}} USD</span> </p>
          <p class="card-text" *ngIf="customer?.other_expenses" >Otros gastos<span class="fw-bold"  > {{customer?.other_expenses}} </span> USD</p>
          <p class="card-text" *ngIf="customer?.family_burden" >Carga familiar<span class="fw-bold"  > {{customer?.family_burden}} </span> </p>



         <!--   <div *ngIf="!estatus_approve" class="w-100 text-end mt-4">
              <a class="btn btn-primary " (click)="setChange(4)">Editar</a>
          </div>-->
      </div>
  </div>
</div>

    <div class="col-12 mt-4">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title">Medios de pago
                    <span *ngIf="sections_status['PAYMENT_METHODS_ONB_APK'] ==  'COMPLETE'" class="float-end  fas fa-check text-success ps-1 small"></span>

                </h5>
                <div class="card-text small">
                    <!-- 🆕 MULTI-PRODUCTO: Vista agrupada por producto -->
                    <div *ngIf="!loadPerson_Address && showGrouped">
                        <div *ngFor="let productCode of getProductKeys(); let p=index">
                            <!-- Card por producto -->
                            <div class="card mb-3 border">
                                <div class="card-header bg-white border-bottom py-2">
                                    <div class="d-flex align-items-center">
                                        <i class="fas fa-box text-secondary me-2"></i>
                                        <strong class="text-dark">{{ getProductName(productCode) }}</strong>
                                        <span class="badge bg-secondary ms-auto">
                                            {{ groupedAccounts[productCode]?.length || 0 }}
                                        </span>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <!-- Cuentas domiciliables -->
                                    <div *ngFor="let item of groupedAccounts[productCode]">
                                        <div *ngIf="item?.bank?.direct_debit_active && item?.direct_debit" class="mb-3">
                                            <div class="d-flex align-items-start">
                                                <i class="fas fa-university text-secondary me-2 mt-1"></i>
                                                <div class="flex-grow-1">
                                                    <div class="fw-bold text-dark">{{item?.bank?.name}} <app-estado-ct-badge [cuenta]="cuentaCt(item, productCode)"></app-estado-ct-badge></div>
                                                    <div class="text-muted small">
                                                        {{ item?.account_type==="00"?"Corriente": "Ahorro" }} • 
                                                        {{item?.currency?.name}} • 
                                                        {{item?.account_number}}
                                                    </div>
                                                    <span class="badge bg-success mt-1" *ngIf="item?.direct_debit_default">
                                                        <i class="fas fa-check-circle me-1"></i>Domiciliada
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!-- Separador entre domiciliables y no domiciliables -->
                                    <hr class="my-2" *ngIf="hasNonDirectDebit(productCode)">
                                    
                                    <!-- Cuentas NO domiciliables -->
                                    <div *ngFor="let item of groupedAccounts[productCode]">
                                        <div *ngIf="!item?.bank?.direct_debit_active || !item?.direct_debit" class="mb-3">
                                            <div class="d-flex align-items-start">
                                                <i class="fas fa-university text-secondary me-2 mt-1"></i>
                                                <div class="flex-grow-1">
                                                    <div class="fw-bold text-dark">{{item?.bank?.name}} <app-estado-ct-badge [cuenta]="cuentaCt(item, productCode)"></app-estado-ct-badge></div>
                                                    <div class="text-muted small">
                                                        {{ item?.account_type==="00"?"Corriente": "Ahorro" }} • 
                                                        {{item?.currency?.name}} • 
                                                        {{item?.account_number}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Vista original (fallback) -->
                    <div *ngIf="!loadPerson_Address && !showGrouped">
                        <div class="mt-2" *ngFor="let item of accounts; let i=index">
                            <div *ngIf="i > 1">
                                <hr>
                            </div>

                            <p class="card-text ">
                                <span class="card-title fw-bold ">{{item?.bank?.name}}</span> <app-estado-ct-badge [cuenta]="cuentaCt(item)"></app-estado-ct-badge>, {{ item?.account_type==="00"?"Corriente": "Ahorro" }}  ({{item?.currency?.name}}), {{item?.account_number}},
                                <span class="text-success">{{item?.direct_debit_default?'Domiciliada':''}}</span>
                            </p>
                        </div>
                    </div>

                    <ng-container *ngIf="loadPerson_Address">
                        <div class="w-100 text-center mt-2">
                            <img src="./assets/public/images/loading.gif  " alt=" ">
                        </div>
                    </ng-container>

                </div>
                <div class="w-100 text-end mt-4">
                    <a class="btn btn-primary " (click)="setChange(5)" *ngIf="_auth.hasPermission('contactos.onboarding.editar_medios_pago')">Editar</a>
                </div>
            </div>

        </div>
    </div>

   <!--<pre>{{ customer | json }}</pre> -->
</div>
